$(document).on('click', '#quote-success .close-popup, #quote-success', function (e) {
  if (e.target === this || $(e.target).hasClass('close-popup')) {
    $('#quote-success').fadeOut();
  }
});

$(document).ready(function () {
  const mainProductId = ShopifyAnalytics?.meta?.product?.id || '{{ product.id }}';
  const shop = Shopify.shop || 'wopa-hoof-trimming-uk.myshopify.com';

  if (mainProductId) {
    const mainProductGid = `gid://shopify/Product/${mainProductId}`;

    fetch('https://cwcreates.co.uk/api/track-product-load', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ main_product_id: mainProductId, shop: shop })
    })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(result => {
        if (!result?.option_data || !result?.all_product_details) {
          throw new Error('Invalid API response');
        }

        window.productMetafields = result.option_data;
        window.allProductDetails = result.all_product_details;

        const mainDet = window.allProductDetails[mainProductGid];
        window.mainProductSku = mainDet?.sku || 'N/A';

        document.getElementById('main-product-title').value = result.title || 'Unknown Product';
        function getProductDetails(id) {
          const gid = id.includes('gid://') ? id : `gid://shopify/Product/${id}`;
          const bare = id.includes('gid://') ? id.split('/').pop() : id;
          const det = window.allProductDetails[gid] || window.allProductDetails[bare] || {
            title: 'Unknown Product',
            image_url: 'https://img.freepik.com/free-vector/illustration-gallery-icon_53876-27002.jpg',
            sku: 'N/A'
          };
          det.sku = det.sku || 'N/A';
          return det;
        }

        let stepsHtml = '';
        window.productMetafields.forEach((cfg, idx) => {
          stepsHtml += `
            <div class="step" data-step="${idx + 1}">
              <div class="step-header"><span class="step-num">${idx + 1}</span> ${cfg.config_title}</div>
              <div class="step-content" style="display:none;">`;

          cfg.sub_products.forEach((sub, sIdx) => {
            const pd = getProductDetails(sub.sub_product_id);

            stepsHtml += `
              <div class="product mc-flex" data-sub-product-id="${sub.sub_product_id}">
                <img class="mc-image" src="${pd.image_url}" alt="${pd.title}" data-fullscreen-src="${pd.image_url}">
                <div class="w50 mc-product-name">${pd.title}</div>
                <div class="w50 mc-text-end">
                  <div class="mc-qty-sub">
                    <div class="quantity-selector">
                      <button class="minus" onclick="updateQuantity(this,-1);toggleRelatedProducts(this)">−</button>
                      <input type="number" min="0" max="${sub.max||1}" value="0"
                             data-product-id="${sub.sub_product_id}"
                             data-product-title="${pd.title}"
                             data-product-sku="${pd.sku}"
                             data-product-image="${pd.image_url}"
                             onchange="updateSelectionCard();toggleRelatedProducts(this)">
                      <button class="plus" onclick="updateQuantity(this,1);toggleRelatedProducts(this)">+</button>
                    </div>
                    <div class="mc-min-max">Max: ${sub.max||1}</div>
                  </div>
                </div>
              </div>`;

            if (sIdx < cfg.sub_products.length - 1) stepsHtml += `<div class="border-bottom-gray"></div>`;

            if (sub.dependent_products?.length) {
              stepsHtml += `<div class="dependent-products" style="display:none;">`;
              sub.dependent_products.forEach((dep, dIdx) => {
                const dd = getProductDetails(dep.id);
                stepsHtml += `
                  <div class="product mc-flex dependent-product" style="margin-left:20px;">
                    <img class="mc-image" src="${dd.image_url}" alt="${dd.title}" data-fullscreen-src="${dd.image_url}">
                    <div class="w50 mc-product-name">${dd.title}</div>
                    <div class="w50 mc-text-end">
                      <div class="mc-qty-sub">
                        <div class="quantity-selector">
                          <button class="minus" onclick="updateQuantity(this,-1)">−</button>
                          <input type="number" min="0" max="1" value="0"
                                 data-product-id="${dep.id}"
                                 data-product-title="${dd.title}"
                                 data-product-sku="${dd.sku}"
                                 data-product-image="${dd.image_url}"
                                 onchange="updateSelectionCard()">
                          <button class="plus" onclick="updateQuantity(this,1)">+</button>
                        </div>
                        <div class="mc-min-max">Max: 1</div>
                      </div>
                    </div>
                  </div>`;
                if (dIdx < sub.dependent_products.length - 1) stepsHtml += `<div class="border-bottom-gray"></div>`;
              });
              stepsHtml += `</div>`;
            }

            if (sub.restricted_products?.length) {
              stepsHtml += `<div class="restricted-products" style="display:none;">`;
              sub.restricted_products.forEach((res, rIdx) => {
                const rd = getProductDetails(res.id);
                stepsHtml += `
                  <div class="product mc-flex restricted-product" style="margin-left:20px;opacity:0.5;">
                    <img class="mc-image" src="${rd.image_url}" alt="${rd.title}" data-fullscreen-src="${rd.image_url}">
                    <div class="w50 mc-product-name">${rd.title}</div>
                    <div class="w50 mc-text-end">
                      <div class="mc-qty-sub">
                        <div class="quantity-selector">
                          <button class="minus" disabled>−</button>
                          <input type="number" min="0" max="1" value="0"
                                 data-product-id="${res.id}"
                                 data-product-title="${rd.title}"
                                 data-product-sku="${rd.sku}"
                                 data-product-image="${rd.image_url}" disabled>
                          <button class="plus" disabled>+</button>
                        </div>
                        <div class="mc-min-max">Max: 1</div>
                      </div>
                    </div>
                  </div>`;
                if (rIdx < sub.restricted_products.length - 1) stepsHtml += `<div class="border-bottom-gray"></div>`;
              });
              stepsHtml += `</div>`;
            }
          });

          stepsHtml += `</div></div>`;
        });

        document.getElementById('steps-container').innerHTML = stepsHtml;
        updateSelectionCard();
      })
      .catch(err => {
        console.error('Page Load API Error:', err);
        alert('Failed to load product configuration. Please try again later.');
      });
  } else {
    alert('Main product ID is missing.');
  }

  $(document).on('click', '.step-header', function () {
    const $step = $(this).closest('.step');
    const $content = $step.find('.step-content');
    $('.step-content').not($content).slideUp();
    $('.step').not($step).removeClass('active');
    $content.slideToggle();
    $step.toggleClass('active');
  });

  $(document).on('click', '.mc-image', function () {
    const src = $(this).attr('data-fullscreen-src');
    if (src) {
      $('#fullscreen-image').attr('src', src);
      $('#fullscreen-image-modal').show();
    }
  });

  $(document).on('click', '.fullscreen-close', function () {
    $('#fullscreen-image-modal').hide();
    $('#fullscreen-image').attr('src', '');
  });

  $('#composition').click(() => {
    $('#collaps-card').show();
    document.querySelector('#collaps-card')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  $('#open-quote-popup').click(() => $('#quote-popup').show());
  $('.close-popup').click(() => { $('#quote-popup').hide(); $('#quote-form')[0].reset(); });

  $('#quote-form').submit(function (e) {
    e.preventDefault();
    const $btn = $('#submit-quote');
    const $loader = $btn.find('.loader');
    const $txt = $btn.find('.button-text');
    if ($btn.hasClass('loading')) return;

    const formData = {
      company_name: $('#company-name').val(),
      first_name: $('#first-name').val(),
      last_name: $('#last-name').val(),
      email: $('#email').val(),
      telephone: $('#telephone').val(),
      street_number: $('#street-number').val(),
      postal_code: $('#postal-code').val(),
      city: $('#city').val(),
      remark: $('#remark').val()
    };

    if (Object.entries(formData).some(([k, v]) => k !== 'company_name' && !v)) {
      alert('Please fill in all required fields');
      return;
    }

    const mainTitle = $('#main-product-title').val();
    if (!mainTitle) { alert('Main product missing'); return; }

    const inputs = document.querySelectorAll('.quantity-selector input');
    const subProducts = Array.from(inputs)
      .filter(i => parseInt(i.value) >= 1 && !i.disabled)
      .map(i => ({
        productId: i.dataset.productId,
        productTitle: i.dataset.productTitle,
        productSku: i.dataset.productSku || 'N/A',
        quantity: parseInt(i.value)
      }));

    const payload = {
      ...formData,
      main_product: {
        productTitle: mainTitle,
        productSku: window.mainProductSku || 'N/A',
        quantity: 1
      },
      sub_products: subProducts
    };

    console.log('Quote payload →', JSON.stringify(payload, null, 2));

    $btn.addClass('loading').prop('disabled', true);
    $loader.removeClass('hidden');
    $txt.text('SUBMITTING...');

    fetch('https://cwcreates.co.uk/api/request-qoute', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(res => {
        console.log('Quote API response:', res);
        $('#quote-form')[0].reset();
        inputs.forEach(i => i.value = '0');
        updateSelectionCard();
        $('#quote-popup').hide();
        $('#quote-success').fadeIn();

        setTimeout(() => {
          $btn.removeClass('loading');
          $loader.addClass('hidden');
          $txt.text('Quote Submitted');
          $btn.prop('disabled', false);
          setTimeout(() => $txt.text('SUBMIT QUOTE'), 3000);
        }, 1000);

        setTimeout(() => $('#quote-success').fadeOut(), 3000);
      })
      .catch(err => {
        console.error(err);
        alert('Quote submission failed');
        $btn.removeClass('loading');
        $loader.addClass('hidden');
        $txt.text('SUBMIT QUOTE');
        $btn.prop('disabled', false);
      });
  });
});

function getProductDetails(id) {
  const gid = id.includes('gid://') ? id : `gid://shopify/Product/${id}`;
  const bare = id.includes('gid://') ? id.split('/').pop() : id;
  const det = window.allProductDetails[gid] || window.allProductDetails[bare] || {
    title: 'Unknown Product',
    image_url: 'https://img.freepik.com/free-vector/illustration-gallery-icon_53876-27002.jpg',
    sku: 'N/A'
  };
  det.sku = det.sku || 'N/A';
  return det;
}

function toggleRelatedProducts(el) {
  const input = el.tagName === 'INPUT' ? el : el.parentElement.querySelector('input');
  const qty = parseInt(input.value) || 0;
  const container = input.closest('.product');
  const step = input.closest('.step');
  const stepIdx = parseInt(step.dataset.step) - 1;

  const depBlock = container.nextElementSibling?.classList.contains('dependent-products')
    ? container.nextElementSibling
    : container.nextElementSibling?.nextElementSibling?.classList.contains('dependent-products')
      ? container.nextElementSibling.nextElementSibling : null;
  if (depBlock) depBlock.style.display = qty > 0 ? 'block' : 'none';

  document.querySelectorAll('.product:not(.dependent-product):not(.restricted-product) .quantity-selector input')
    .forEach(i => {
      i.disabled = false;
      i.closest('.quantity-selector').querySelectorAll('button').forEach(b => b.disabled = false);
      i.closest('.product').style.opacity = '1';
    });

  const mf = window.productMetafields || [];
  mf.forEach((cfg, cfgIdx) => {
    const selInputs = document.querySelectorAll(`.step[data-step="${cfgIdx + 1}"] .product:not(.dependent-product):not(.restricted-product) .quantity-selector input`);
    selInputs.forEach(si => {
      if ((parseInt(si.value) || 0) > 0) {
        const sub = cfg.sub_products.find(s => s.sub_product_id === si.dataset.productId ||
          `gid://shopify/Product/${s.sub_product_id}` === si.dataset.productId);
        if (sub?.restricted_products) {
          sub.restricted_products.forEach(r => {
            document.querySelectorAll(`.quantity-selector input[data-product-id="${r.id}"], .quantity-selector input[data-product-id="gid://shopify/Product/${r.id}"]`)
              .forEach(ri => {
                if (!ri.closest('.dependent-product')) {
                  ri.disabled = true;
                  ri.closest('.quantity-selector').querySelectorAll('button').forEach(b => b.disabled = true);
                  ri.closest('.product').style.opacity = '0.5';
                }
              });
          });
        }
      }
    });
  });

  updateSelectionCard();
}

function updateQuantity(btn, delta) {
  const input = btn.parentElement.querySelector('input');
  let v = parseInt(input.value) + delta;
  const max = parseInt(input.getAttribute('max')) || 1;
  const min = parseInt(input.getAttribute('min')) || 0;
  if (v > max) v = max;
  if (v < min) v = min;
  input.value = v;
  updateSelectionCard();
  toggleRelatedProducts(input);
}
function updateSelectionCard() {
  const list = document.getElementById('selection-list');
  list.innerHTML = '';

  const mainTitle = document.getElementById('main-product-title').value;
  if (mainTitle) {
    const div = document.createElement('div');
    div.className = 'mc-products border-bottom mc-flex';
    div.innerHTML = `
      <div class="w50"><span class="main-product-label">Main Product:</span> ${mainTitle} <small>(SKU: ${window.mainProductSku})</small></div>
      <div class="w50 mc-text-end">1</div>`;
    list.appendChild(div);
  }

  const selected = new Map();
  document.querySelectorAll('.quantity-selector input').forEach(i => {
    const qty = parseInt(i.value);
    const id = i.dataset.productId;
    if (qty >= 1 && !i.disabled && !selected.has(id)) {
      selected.set(id, {
        title: i.dataset.productTitle,
        img: i.dataset.productImage,
        sku: i.dataset.productSku || 'N/A',
        qty
      });
    }
  });

  selected.forEach(o => {
    const div = document.createElement('div');
    div.className = 'mc-products border-bottom mc-flex';
    div.innerHTML = `
      <div class="w50">
        <img class="mc-image" src="${o.img}" alt="${o.title}" data-fullscreen-src="${o.img}">
        ${o.title} <small>(SKU: ${o.sku})</small>
      </div>
      <div class="w50 mc-text-end">${o.qty}</div>`;
    list.appendChild(div);
  });
}